import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LocationService } from "../../../services/locationService";
import { SearchResponse } from "../../../objects/responses/searchResponse";
import { LocationType } from "../../../objects/management/locationManagement/locationType";
import { InlineSelectModel } from "../../common/inlineSelect/inlineSelectModel";
import { Location } from "../../../objects/management/locationManagement/location";
import { LMCreateModalComponent } from "./locationModals/locationManagementCreateModal.component";
import { LocationSearchRequest } from "../../../objects/requests/locationSearchRequest";
import { PaginationInstance } from "ngx-pagination";

import * as ps from "perfect-scrollbar"
import { BlurUtil } from "../../../common/utils/blurUtil";

/**
 * Created by alex.y on 7/31/2017.
 */

@Component({
    selector: "location-management",
    templateUrl: "./locationManagement.component.html",
    moduleId: module.id.toString()
})
export class LocationManagementComponent implements OnInit {

    @ViewChild('createModal') createModal: LMCreateModalComponent;

    public searchResponse: SearchResponse<Location> = new SearchResponse();

    public searchQuery: Location = new Location();

    public currentOffset = 0;

    public idToBlur: string = "location-management";

    public config: PaginationInstance = {
        id: 'custom',
        itemsPerPage: 12,
        currentPage: 1,
        totalItems: 1
    };

    constructor(private route: ActivatedRoute, private locationService: LocationService) {
    }

    @HostListener('window:popstate', ['$event'])
    unBlurMenu(): void {
        BlurUtil.unBlurMenu(this.idToBlur);
    }

    public ngOnInit(): void {
        this.searchResponse = this.route.snapshot.data.locations;
        this.config.totalItems = this.route.snapshot.data.locations.TotalCount;
    }

    public searchLocations(searchQuery: Location): void {
        if(searchQuery == null)
            return;

        this.searchQuery = searchQuery;
        this.currentOffset = 0;
        this.search();
    }

    public setPage(offset: number) {
        this.currentOffset = offset;
        this.search();
    }

    public search(): void {
        this.locationService.search(new LocationSearchRequest({
            Skip: (this.config.currentPage - 1) * this.config.itemsPerPage,
            Top: this.config.itemsPerPage,
            Country: this.searchQuery.Country,
            City: this.searchQuery.City,
            Street: this.searchQuery.Street
        })).then((response) => {
            if (!response || !response.Data)
                return;

            document.getElementById('mainPanel').scrollTop = 0;

            this.config.totalItems = response.Data.TotalCount;
            this.searchResponse = response.Data;
        });
    }

    public showCreateModal(): void {
        this.createModal.show();
    }

    public locationCreatedHandler(location: Location): void {
        let existingLocation = this.searchResponse.Items.find(x => x.Id == location.Id);

        if (existingLocation != null) {
            Object.assign(existingLocation, location);
        } else {
            this.searchResponse.Items.unshift(location);

            if(this.searchResponse.Items.length > this.config.itemsPerPage)
                this.searchResponse.Items.pop();

            this.config.totalItems += 1;
        }
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/locationManagement/locationManagement.component.ts